module.exports = "<td class=grid-content> {{#if bodyData.isPartOfMonth}} {{#if bodyData.isToday}} <span class=date style=background-color:red;color:#fff>今天</span> {{else}} <span class=date style=color:#666>{{bodyData.dayNum}}</span> {{#if bodyData.dayName}} <span class=dayName>{{bodyData.dayName}}</span> {{/if}} {{/if}} {{else}} <span class=date style=color:#333>{{bodyData.dayNum}}</span> {{/if}} <div class=task-list> </div> </td>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.subcomponent/calendar.table.grid/calendar.table.grid.html
// module id = 4938
// module chunks = 50